import Footer from 'components/Footer';
import Header from 'components/Header';
import { wrapWithLoaderProvider } from 'context/LoaderProvider';
import { wrapWithToastProvider } from 'context/ToastContext';
import React, { useEffect } from 'react';
import { Outlet, useLocation, useNavigate } from 'react-router-dom';

const MainLayout = () => {
  const location = useLocation();
  const navigate = useNavigate();

  useEffect(() => {
    if (location.search != null && location.search !== '') {
      navigate(location.pathname, { replace: true });
    }
  }, [location.search]);

  return (
    <>
      <Header />
      <main>
        <Outlet />
      </main>
      <Footer />
    </>
  );
};
export default wrapWithToastProvider(wrapWithLoaderProvider(MainLayout));
